/* unplugin-vue-components disabled *//* vant-demand-import */
import installComponents from "!../../../plugins/vant-demand-import/installComponents.js"
import VanIcon from 'vant/es/icon'
import 'vant/es/icon/style/less'


import { render, staticRenderFns } from "./NavBar.vue.js?vue&type=template&id=f988c104!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NavBar.vue?vue&type=template&id=f988c104"
import script from "./NavBar.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NavBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./NavBar.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NavBar.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NavBar.vue.postcss?vue&type=style&index=0&id=f988c104&prod&lang=postcss!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./NavBar.vue?vue&type=style&index=0&id=f988c104&prod&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
installComponents(component, {VanIcon})
